import type { ReactElement } from 'react'
import type { GlyphKey, Star } from '@origami/shared'
import { ImgGlyph } from './ImgGlyph'
import { UnitGlyph } from '../UnitGlyph'
import { TIERED_GLYPHS } from './tieredGlyphs'
import { UNIT_TINTS } from './unitTints'

interface TieredCritterProps {
  glyph: GlyphKey
  star: Star
  size?: number
  /** Optional unit_id for per-unit tint lookup. When two units share
   *  a glyph, passing the id lets TieredCritter apply a
   *  differentiating CSS filter via UNIT_TINTS. Omit when the
   *  rendering context is generic (gallery / icon picker / etc.). */
  unitId?: string
}

/**
 * TieredCritter — renders a unit at a specific star tier.
 *
 * Looks up (glyph, star) in TIERED_GLYPHS. If a per-tier asset is
 * registered, renders it via ImgGlyph. Otherwise falls back to the
 * base GLYPHS[glyph] silhouette so the system works as art ships.
 */
export function TieredCritter({
  glyph,
  star,
  size = 100,
  unitId,
}: TieredCritterProps): ReactElement {
  const tint = unitId ? UNIT_TINTS[unitId] : undefined
  const path = TIERED_GLYPHS[glyph]?.[star]
  if (path) return <ImgGlyph src={path} size={size} alt="" tint={tint} />
  return <UnitGlyph unit={{ glyph }} size={size} />
}
